{
    "ShowHeaderRowLabel": "Kopfzeile anzeigen:",
    "ShowFooterRowLabel": "Fußzeile anzeigen:",
    "ShowContentRowsLabel": "Inhaltszeilen anzeigen:",
    "ShowSpacerRowsLabel": "Abstandsreihe(n) anzeigen:",
    "NAME": "ReportContentRowsSettingsLanguage"
}